import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface ProcurementFeature {
  title: string;
  image: string;
  points: string[];
}

@Component({
  selector: 'app-procurement-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './procurement-features.html',
  styleUrls: ['./procurement-features.css'],
})
export class ProcurementFeaturesComponent {
  readonly features: ProcurementFeature[] = [
    {
      title: 'Vendor Management',
      image: 'images/modules/vendors.PNG',
      points: ['Supplier master data', 'Approval before use', 'Bank accounts & contacts'],
    },
    {
      title: 'Vendor Categories',
      image: 'images/modules/vendors-categories.PNG',
      points: ['Classify by supplier type', 'Segmentation & reporting', 'Custom categories'],
    },
    {
      title: 'Purchase Requisitions',
      image: 'images/modules/purchase.PNG',
      points: ['Budget-checked requests', 'Priority & approval routing', 'Required-by tracking'],
    },
    {
      title: 'Purchase Orders',
      image: 'images/modules/order.PNG',
      points: ['Order-to-invoice tracking', 'Outstanding balance visibility', 'Vendor-linked orders'],
    },
    {
      title: 'Goods Receipts (GRN)',
      image: 'images/modules/grn.PNG',
      points: ['Record deliveries against POs', 'Line-level receiving', 'Posted status tracking'],
    },
    {
      title: 'Vendor Bills',
      image: 'images/modules/bill.PNG',
      points: ['3-way matching', 'Partial & full payments', 'Overdue tracking'],
    },
    {
      title: 'Approval Workflows',
      image: 'images/modules/approval.PNG',
      points: ['Multi-level approval chains', 'Amount-based routing', 'Escalation on delay'],
    },
  ];
}
